import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { BorderOuterLeftGradient } from 'atoms/BorderOuter/Templates'
import { IconNames } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Corners, Fonts, Paddings } from '../Label.h'

export interface ILabelWithBorderLeftProps extends ILabelProps {
  withIcon?: boolean
}

export const LabelWithBorderLeft = ({
  title = '',
  withIcon,
  background = Backgrounds.SURFACE_OPACITY_DARK_40,
  padding = Paddings.SIZE_20,
  font = Fonts.Caption1,
  color = COLOR.TEXT_ICON_CONSTANT_LIGHT,
  corners = Corners.CORNERS_LEFT_10,
  ...rest
}: ILabelWithBorderLeftProps): JSX.Element => (
  <BorderOuterLeftGradient corners={corners}>
    <Label
      title={title}
      icon={withIcon ? IconNames.crown : null}
      background={background}
      padding={padding}
      font={font}
      color={color}
      corners={Corners.CORNERS_RIGHT_10}
      {...rest}
    />
  </BorderOuterLeftGradient>
)
